import { ChartBinSize, ChartDefinition, ChartKey, ChartQueryParam, ChartRendererType } from '@frontend/chart/types';

import { IOTS_VOLUME_CHART_ENDPOINT } from '../iot-chart-endpoints';

export const IOTS_VOLUME_BY_STATUS_DONUT_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.IOTS_VOLUME_BY_STATUS_DONUT,
    chartType: ChartRendererType.PIE,
    endpoint: IOTS_VOLUME_CHART_ENDPOINT,
    filters: [{ key: ChartQueryParam.BIN_SIZE, value: ChartBinSize.FULL_PERIOD }],
    groupBy: ChartQueryParam.STATUS
};
